module.exports = __webpack_public_path__ + "img/img-2-3.be08d04e.webp";